





















import { Component, Prop, Vue } from 'vue-property-decorator';
import SingleAvatar from '@/components/SingleAvatar.vue';

@Component({
    components: { SingleAvatar }
})
export default class EditorPreview extends Vue {
    @Prop()
    character!: string;

    @Prop()
    setName!: string;

    @Prop({
        default: false
    })
    loading!: boolean;
}
